import { Terms } from "@/api/functions/cms.api";
import Terms_Privacy from "@/components/Terms_Condition_Privacy_Policy/Terms_Privacy";
import Wrapper from "@/layout/wrapper/Wrapper";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { NextSeo } from "next-seo";

function index() {
  return (
    <Wrapper>
      <NextSeo noindex={false} nofollow={false} />
      <Terms_Privacy slug="terms-and-condition" />
    </Wrapper>
  );
}

export default index;
